import React from "react";
import { Point, ProgressBarDiv, FillerDiv, OverlayDiv } from "./OnboardingProgressBar";

export interface ProgressBarProps {
  childrenLength: number;
  currentIndex: number;
}

const ImprintOnboardingProgressBar: React.FC<ProgressBarProps> = ({
  childrenLength,
  currentIndex,
}) => {
  return (
    <ProgressBarDiv childrenLength={childrenLength} currentIndex={currentIndex}>
      <FillerDiv childrenLength={childrenLength} currentIndex={currentIndex} />
      <OverlayDiv>
        <Point
          startIdx={0}
          endIdx={6}
          currIdx={currentIndex}
          text="About Me"
          number={1}
          position={0}
          align="right"
        />
        <Point
          startIdx={7}
          endIdx={18}
          currIdx={currentIndex}
          text="MY MINDSET"
          number={2}
          position={Math.floor((7 / (childrenLength - 1)) * 100)}
        />
        <Point
          startIdx={19}
          endIdx={childrenLength - 1}
          currIdx={currentIndex}
          text="MY LIFE"
          number={3}
          position={Math.floor((19 / (childrenLength - 1)) * 100) - 1}
        />
      </OverlayDiv>
    </ProgressBarDiv>
  );
};

export default ImprintOnboardingProgressBar;
